import React from "react";
import {Col, Container, Row} from "react-bootstrap";
import RightArrowButton from "./RightArrowButton";

export default function StatusButton(props) {

    return (<>
        <Container fluid className={props.isActionColBtn?"d-none" : "m-0 p-0"}>
            <Col className="text-nowrap d-block d-sm-none p-0 m-0">
                <Row onClick={props.onStatusButtonClick}>
                    <Col xs={6} className={'py-2 pl-4'} style={{alignSelf: 'center'}}><p style={{float: 'left'}}>Status</p></Col>
                    <Col xs={6} className={'py-2 pr-2'} style={{alignSelf: 'center'}}> <RightArrowButton/></Col>
                    <Col xs={12} className={'py-2 pr-0 pl-3'}><hr/></Col>
                </Row>
            </Col>
        </Container>
    </>)
}